module.exports = __webpack_public_path__ + "static/img/4.1.f3387b86.png";